<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="filter_cluster">Filter By Cluster</label>
            <v-select
              id="filter_cluster"
              v-model="selected.filter_cluster"
              :options="list.filter_clusters"
              label="cluster_name"
              :disabled="state.busy"
              placeholder="-- Please Select Cluster --"
            >
              <template #option="{ cluster_name }">
                <span>{{ cluster_name }}</span>
              </template>
              <template #no-options="">
                No Available Clusters
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="selectedArea">Filter by Area</label>
            <v-select
              id="selectedArea"
              v-model="selected.filter_area"
              :options="list.filter_areas"
              label="area_name"
              placeholder="-- Please Select Area --"
            >
              <template #option="{ area_name }">
                <strong>{{ area_name }}</strong>
              </template>
              <template #no-options="">
                No Available Areas
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="call_status">Filter By Last Call Status</label>
            <v-select
              id="call_status"
              v-model="selected.filter_call_status"
              :options="options.filter_call_statuses"
              label="text"
              :disabled="state.busy"
              placeholder="-- Please Select Call Status --"
            >
              <template #option="{ text }">
                <span>{{ text }}</span>
              </template>
              <template #no-options="">
                No Available Call Statuses
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="unsuccessful_reason">Filter By Last Unsuccessful Reason</label>
            <v-select
              id="unsuccessful_reason"
              v-model="selected.filter_unsuccessful_reason"
              :options="filterUnsuccessfulReasons"
              label="reason_name"
              placeholder="-- Please Select Unsuccessful Reason --"
            >
              <template #option="{ reason_name }">
                <span>{{ reason_name }}</span>
              </template>
              <template #no-options="">
                No Available Unsuccessful Reasons
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ tableSettings.currentPage * tableSettings.perPage - tableSettings.perPage + (data.index + 1) }}
        </template>

        <template #cell(submitted_by)="data">
          <div class="text-nowrap">
            {{ `${data.item.submitted_by?.first_name || ''} ${data.item.submitted_by?.last_name || ''}` }}
          </div>
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              variant="secondary"
              class="ml-2"
              @click="onShowEditForm(row.item)"
            >
              Process
            </b-button>
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-process-form"
      scrollable
      no-close-on-backdrop
      title="Process Pending Data"
      size="xl"
      @ok="onConfirmAction"
    >
      <ValidationObserver ref="form">
        <form
          role="form"
          novalidate
        >
          <b-tabs
            class="px-2"
            no-body
          >
            <b-tab
              title="Personal Information"
              active
            >
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="first name"
                    vid="first_name"
                    rules="required|max:50"
                  >
                    <b-form-group>
                      <label for="first_name"><strong>First name</strong></label>
                      <b-input
                        id="first_name"
                        v-model="rawData.first_name"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter first name"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="last name"
                    vid="last_name"
                    rules="required|max:50"
                  >
                    <b-form-group>
                      <label for="last_name"><strong>Last Name</strong></label>
                      <b-input
                        id="last_name"
                        v-model="rawData.last_name"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter last name"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="customer type"
                    vid="customer_type"
                    :rules="rulesCustomerType"
                  >
                    <b-form-group>
                      <label for="customer_type"><strong>Customer Type</strong></label>
                      <b-form-select
                        id="customer_type"
                        v-model="rawData.customer_type"
                        :options="options.customer_types"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Customer Type --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="mobile number"
                    vid="mobile_number"
                    rules="required|min:11|max:11"
                  >
                    <b-form-group>
                      <label for="mobile_number"><strong>Mobile Number</strong></label>
                      <b-input
                        id="mobile_number"
                        v-model="rawData.mobile_number"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter contact number"
                        autocomplete="off"
                        maxlength="11"
                        :disabled="true"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="email"
                    vid="email"
                    rules="email|max:100"
                  >
                    <b-form-group>
                      <label for="email"><strong>Email</strong></label>
                      <b-input
                        id="email"
                        v-model="rawData.email"
                        type="email"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter email"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="birth date"
                    vid="birth_date"
                  >
                    <b-form-group>
                      <label for="birth_date"><strong>Birth Date</strong></label>
                      <b-input
                        id="birth_date"
                        v-model="rawData.birth_date"
                        type="date"
                        placeholder="enter birth date"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="gender"
                    vid="gender"
                  >
                    <b-form-group>
                      <label for="gender"><strong>Gender</strong></label>
                      <b-form-select
                        id="gender"
                        v-model="rawData.gender"
                        :options="options.genders"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Gender --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="experience"
                    vid="experience"
                    rules="required|numeric"
                  >
                    <b-form-group>
                      <label for="experience"><strong>Years in Farming</strong></label>
                      <b-input
                        id="experience"
                        v-model="rawData.experience"
                        type="text"
                        placeholder="enter years in farming"
                        autocomplete="off"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="primary dialect"
                    vid="primary_dialect"
                    rules=""
                  >
                    <b-form-group>
                      <label for="primary_dialect"><strong>Primary Dialect</strong></label>
                      <b-form-select
                        id="primary_dialect"
                        v-model="rawData.primary_dialect"
                        :options="list.dialects"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Primary Dialect --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="secondary dialect"
                    vid="secondary_dialect"
                    rules=""
                  >
                    <b-form-group>
                      <label for="secondary_dialect"><strong>Secondary Dialect</strong></label>
                      <b-form-select
                        id="secondary_dialect"
                        v-model="rawData.secondary_dialect"
                        :options="list.dialects"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Secondary Dialect --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="number of household"
                    vid="number_of_household"
                    rules="required|numeric"
                  >
                    <b-form-group>
                      <label for="number_of_household"><strong>Number Of Household</strong></label>
                      <b-input
                        id="number_of_household"
                        v-model="rawData.number_of_household"
                        type="text"
                        placeholder="enter number of house hold"
                        autocomplete="off"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="occupation"
                    vid="occupation"
                    rules="max:100"
                  >
                    <b-form-group>
                      <label for="occupation"><strong>Occupation</strong></label>
                      <b-input
                        id="occupation"
                        v-model="rawData.occupation"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter occupation"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="other occupation"
                    vid="other_occupation"
                    rules="max:100"
                  >
                    <b-form-group>
                      <label for="other_occupation"><strong>Other Occupation</strong></label>
                      <b-input
                        id="other_occupation"
                        v-model="rawData.other_occupation"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter other occupation"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="dealers"
                    vid="dealers"
                    rules=""
                  >
                    <b-form-group>
                      <label for="dealers"><strong>Branch / Dealer</strong></label>
                      <v-select
                        id="dealers"
                        v-model="rawData.dealers"
                        :options="list.dealers"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="partner_name"
                        :disabled="state.busy"
                        multiple
                      >
                        <template #option="{ partner_name }">
                          <strong>{{ partner_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Dealers
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="other dealer"
                    vid="other_dealer"
                    rules="max:100"
                  >
                    <b-form-group>
                      <label for="other_dealer"><strong>Other Dealer</strong></label>
                      <b-input
                        id="other_dealer"
                        v-model="rawData.other_dealer"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter other dealer"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="cluster"
                    vid="cluster"
                    rules=""
                  >
                    <b-form-group>
                      <label for="cluster"><strong>Cluster</strong></label>
                      <v-select
                        id="cluster"
                        v-model="selected.cluster"
                        :options="list.clusters"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="cluster_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ cluster_name }">
                          <strong>{{ cluster_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Clusters
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="areas"
                    vid="areas"
                    rules=""
                  >
                    <b-form-group>
                      <label for="areas"><strong>Area</strong></label>
                      <v-select
                        id="areas"
                        v-model="selected.area"
                        :options="list.areas"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="area_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ area_name }">
                          <strong>{{ area_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Clusters
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="street name"
                    vid="street_name"
                    rules="max:100"
                  >
                    <b-form-group>
                      <label for="street_name"><strong>Street Name</strong></label>
                      <b-input
                        id="street_name"
                        v-model="rawData.street_name"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter street name"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="province"
                    vid="province"
                    rules=""
                  >
                    <b-form-group>
                      <label for="province"><strong>Province</strong></label>
                      <v-select
                        id="province"
                        v-model="selected.province"
                        :options="list.provinces"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="province_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ province_name }">
                          <strong>{{ province_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Provinces
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="municipality"
                    vid="municipality"
                    rules=""
                  >
                    <b-form-group>
                      <label for="municipality"><strong>Municipality</strong></label>
                      <v-select
                        id="municipality"
                        v-model="selected.municipality"
                        :options="list.municipalities"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="municipality_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ municipality_name }">
                          <strong>{{ municipality_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Municipalities
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="barangay"
                    vid="barangay"
                    rules=""
                  >
                    <b-form-group>
                      <label for="barangay"><strong>Barangay</strong></label>
                      <v-select
                        id="arangay"
                        v-model="selected.barangay"
                        :options="list.barangays"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="barangay_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ barangay_name }">
                          <strong>{{ barangay_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Barangays
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="farm address"
                    vid="farm_address"
                    rules="max:500"
                  >
                    <b-form-group>
                      <label for="farm_address"><strong>Farm Address</strong></label>
                      <b-input
                        id="farm_address"
                        v-model="rawData.farm_address"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter farm address"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="mode of payment"
                    vid="mop"
                    rules=""
                  >
                    <b-form-group>
                      <label for="mode_of_payment"><strong>Mode of Payment</strong></label>
                      <b-form-select
                        id="mode_of_payment"
                        v-model="rawData.mop"
                        :options="list.mode_of_payments"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Mode of Payment --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="Mode of Communication"
                    vid="moc"
                    rules=""
                  >
                    <b-form-group>
                      <label for="mode_of_communication"><strong>Mode of Communication</strong></label>
                      <b-form-select
                        id="mode_of_communication"
                        v-model="rawData.moc"
                        :options="list.mode_of_communications"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Mode of Communication --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="preferred time"
                    vid="preferred_time"
                    rules=""
                  >
                    <b-form-group>
                      <label for="preferred_time"><strong>Preferred Time</strong></label>
                      <b-form-select
                        id="preferred_time"
                        v-model="rawData.preferred_time"
                        :options="options.schedules"
                        :disabled="state.busy"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Preferred Time --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="raisers"
                    vid="raisers"
                    rules=""
                  >
                    <b-form-group>
                      <label for="raisers"><strong>Raisers</strong></label>
                      <v-select
                        id="raisers"
                        v-model="rawData.raisers"
                        :options="list.raisers"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="raiser_name"
                        :disabled="state.busy"
                        multiple
                      >
                        <template #option="{ raiser_name }">
                          <strong>{{ raiser_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Raisers
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  class="mb-5"
                >
                  <b-form-group>
                    <label><strong>Source Remarks</strong></label>
                    <b-textarea
                      :value="rawData.source_remarks"
                      :disabled="true"
                      rows="4"
                      max-rows="4"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab title="Custom Fields">
              <b-row>
                <b-col
                  cols="12"
                >
                  <b-form-group>
                    <label for="field"><strong>Custom Field</strong></label>
                    <b-form-select
                      id="field"
                      v-model="customField.field"
                      :options="list.custom_fields"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- Please Select Custom Field --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                >
                  <b-form-group>
                    <label for="field_value"><strong>Custom Value</strong></label>
                    <b-textarea
                      id="field_value"
                      v-model="customField.field_value"
                      rows="6"
                      max-rows="6"
                      placeholder="enter value"
                      autocomplete="off"
                      :disabled="customField.field === null"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  class="mb-3"
                >
                  <b-button
                    type="button"
                    variant="success"
                    class="mr-2"
                    :disabled="customFieldInserButttonDisabledState"
                    @click="onCustomFieldInsert"
                  >
                    Insert Field
                  </b-button>

                  <b-button
                    type="button"
                    variant="secondary"
                    @click="onCustomFieldRefresh"
                  >
                    Refresh List
                  </b-button>
                </b-col>

                <b-col
                  v-for="(field, key) in rawData.custom_fields"
                  :key="key"
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label :for="field.field_label"><strong>{{ field.field_label }}</strong></label>
                    <b-textarea
                      :id="field.field_label"
                      v-model="field.field_value"
                      rows="6"
                      max-rows="6"
                      placeholder="enter value"
                      autocomplete="off"
                      :disabled="true"
                    />
                    <a
                      v-if="isNaN(parseInt(field.id))"
                      href="javascript:void(0);"
                      class="text-danger"
                      @click="onCustomFieldRemove(field)"
                    >Remove Field</a>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-tab>

            <b-tab title="Crop Details">
              <b-row>
                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="Crop"
                    vid="crop"
                  >
                    <b-form-group>
                      <label for="crop"><strong>Crop</strong></label>
                      <b-form-select
                        id="crop"
                        v-model="cropDetail.crop"
                        :options="list.crops"
                        :state="errors.length > 0 ? false : null"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Crop --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="Field Size"
                    vid="field_size"
                  >
                    <b-form-group>
                      <label for="field_size"><strong>Field Size</strong></label>
                      <b-form-select
                        id="field_size"
                        v-model="cropDetail.field_size"
                        :options="list.field_sizes"
                        :state="errors.length > 0 ? false : null"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Field Size --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="Number of Hectares"
                    vid="number_of_hectares"
                    rules="double|max_value:200"
                  >
                    <b-form-group>
                      <label for="number_of_hectares"><strong>Number of Hectares</strong></label>
                      <b-input
                        id="number_of_hectares"
                        v-model="cropDetail.number_of_hectares"
                        type="number"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter number of hectares"
                        autocomplete="off"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col cols="12">
                  <b-button
                    class="mr-2"
                    type="button"
                    :variant="cropDetailButtonVariant"
                    :disabled="cropDetailButtonDisabledState"
                    @click="onCropDetailButtonClick"
                  >
                    {{ cropDetailButtonLabel }}
                  </b-button>
                  <b-button
                    v-if="state.cropDetailEditing"
                    type="button"
                    variant="danger"
                    @click="onCropDetailCancelUpdate"
                  >
                    Cancel Update
                  </b-button>
                </b-col>

                <b-col
                  cols="12"
                  class="mt-2"
                >
                  <b-table
                    ref="table-crop-details"
                    hover
                    responsive
                    show-empty
                    :fields="tableCropDetails.fields"
                    :items="filteredCustomerCropDetails"
                  >
                    <template #cell(index)="data">
                      {{ tableCropDetails.currentPage * tableCropDetails.perPage - tableCropDetails.perPage + (data.index + 1) }}
                    </template>
                    <template #cell(actions)="row">
                      <div class="text-nowrap">
                        <b-button
                          size="sm"
                          variant="success"
                          class="mr-2"
                          :disabled="state.cropDetailEditing"
                          @click="onCropDetailEdit(row.item)"
                        >
                          Edit
                        </b-button>

                        <b-button
                          v-if="isNaN(parseInt(row.item.id))"
                          size="sm"
                          variant="danger"
                          :disabled="state.cropDetailEditing"
                          @click="onCropDetailRemove(row.item)"
                        >
                          Remove
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab title="Crop Histories">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                >

                  <b-form-group>
                    <label for="cropping_season"><strong>Cropping Season</strong></label>
                    <v-select
                      id="cropping_season"
                      v-model="selected2.cropping_season"
                      :options="list.cropping_seasons"
                      label="text"
                      placeholder="-- Please Select Cropping Season --"
                    >
                      <template #option="{ text }">
                        <span>{{ text }}</span>
                      </template>
                      <template #no-options="">
                        No Available Cropping Seasons
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >

                  <b-form-group>
                    <label for="cropping_year"><strong>Cropping Year</strong></label>
                    <v-select
                      id="cropping_year"
                      v-model="selected2.cropping_year"
                      :options="list.cropping_years"
                      label="text"
                      placeholder="-- Please Select Cropping Year --"
                    >
                      <template #option="{ text }">
                        <span>{{ text }}</span>
                      </template>
                      <template #no-options="">
                        No Available Cropping Years
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="crop"><strong>Crop</strong></label>
                    <v-select
                      id="crop"
                      v-model="selected2.crop"
                      :options="list.crops"
                      label="text"
                      placeholder="-- Please Select Crop --"
                    >
                      <template #option="{ text }">
                        <span>{{ text }}</span>
                      </template>
                      <template #no-options="">
                        No Available Crops
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >

                  <b-form-group>
                    <label for="classification"><strong>Crop Classification</strong></label>
                    <v-select
                      id="classification"
                      v-model="selected2.classification"
                      :options="list.classifications"
                      label="classification_name"
                      :disabled="selected2.crop === null"
                      placeholder="-- Please Select Crop Classification --"
                    >
                      <template #option="{ classification_name }">
                        <span>{{ classification_name }}</span>
                      </template>
                      <template #no-options="">
                        No Available Crop Classifications
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="varieties"><strong>Crop Varieties</strong></label>
                    <v-select
                      id="varieties"
                      v-model="selected2.varieties"
                      :options="list.varieties"
                      label="variety_name"
                      :disabled="selected2.crop === null"
                      multiple
                      placeholder="-- Please Select Crop Varieties --"
                    >
                      <template #option="{ variety_name }">
                        <span>{{ variety_name }}</span>
                      </template>
                      <template #no-options="">
                        No Available Crop Varieties
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="herbicide_ones"><strong>Crop Herbicides</strong></label>
                    <v-select
                      id="herbicide_ones"
                      v-model="selected2.herbicide_ones"
                      :options="list.herbicides"
                      label="herbicide_name"
                      :disabled="selected2.crop === null"
                      multiple
                      placeholder="-- Please Select Crop Herbicides --"
                    >
                      <template #option="{ herbicide_name }">
                        <span>{{ herbicide_name }}</span>
                      </template>
                      <template #no-options="">
                        No Available Crop Herbicides
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="herbicide_twos"><strong>Crop Herbicides (Dike)</strong></label>
                    <v-select
                      id="herbicide_twos"
                      v-model="selected2.herbicide_twos"
                      :options="list.herbicides"
                      label="herbicide_name"
                      :disabled="selected2.crop === null"
                      multiple
                      placeholder="-- Please Select Crop Herbicides --"
                    >
                      <template #option="{ herbicide_name }">
                        <span>{{ herbicide_name }}</span>
                      </template>
                      <template #no-options="">
                        No Available Crop Herbicides
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="fungicides"><strong>Crop Fungicides</strong></label>
                    <v-select
                      id="fungicides"
                      v-model="selected2.fungicides"
                      :options="list.fungicides"
                      label="fungicide_name"
                      :disabled="selected2.crop === null"
                      multiple
                      placeholder="-- Please Select Crop Fungicides --"
                    >
                      <template #option="{ fungicide_name }">
                        <span>{{ fungicide_name }}</span>
                      </template>
                      <template #no-options="">
                        No Available Crop Fungicides
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="insecticides"><strong>Crop Insecticides</strong></label>
                    <v-select
                      id="insecticides"
                      v-model="selected2.insecticides"
                      :options="list.insecticides"
                      label="insecticide_name"
                      :disabled="selected2.crop === null"
                      multiple
                      placeholder="-- Please Select Crop Insecticides --"
                    >
                      <template #option="{ insecticide_name }">
                        <span>{{ insecticide_name }}</span>
                      </template>
                      <template #no-options="">
                        No Available Crop Insecticides
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="fertilizers"><strong>Crop Fertilizers</strong></label>
                    <v-select
                      id="fertilizers"
                      v-model="selected2.fertilizers"
                      :options="list.fertilizers"
                      label="fertilizer_name"
                      :disabled="selected2.crop === null"
                      multiple
                      placeholder="-- Please Select Crop Fertilizers --"
                    >
                      <template #option="{ fertilizer_name }">
                        <span>{{ fertilizer_name }}</span>
                      </template>
                      <template #no-options="">
                        No Available Crop Fertilizers
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-button
                    class="mr-2"
                    type="button"
                    :variant="cropHistoryButtonVariant"
                    :disabled="cropHistoryButtonDisabledState"
                    @click="onCropHistoryButtonClick"
                  >
                    {{ cropHistoryButtonLabel }}
                  </b-button>
                  <b-button
                    v-if="state.cropHistoryEditing"
                    type="button"
                    variant="danger"
                    @click="onCropHistoryCancelUpdate"
                  >
                    Cancel Update
                  </b-button>
                </b-col>

                <b-col
                  cols="12"
                  class="mt-2"
                >
                  <b-table
                    ref="table-crop-history"
                    class="mt-5"
                    hover
                    responsive
                    show-empty
                    :fields="tableCropHistories.fields"
                    :items="filteredCustomerCropHistories"
                  >
                    <template #cell(index)="data">
                      {{ tableCropHistories.currentPage * tableCropHistories.perPage - tableCropHistories.perPage + (data.index + 1) }}
                    </template>

                    <template #cell()="data">
                      <div class="text-nowrap">
                        {{ data.value }}
                      </div>
                    </template>

                    <template #cell(actions)="row">
                      <div class="text-nowrap">
                        <b-button
                          size="sm"
                          variant="success"
                          :disabled="state.cropHistoryEditing"
                          class="mr-2"
                          @click="onCropHistoryEdit(row.item)"
                        >
                          Edit
                        </b-button>

                        <b-button
                          v-if="isNaN(parseInt(row.item.id))"
                          size="sm"
                          variant="danger"
                          :disabled="state.cropHistoryEditing"
                          @click="onCropHistoryRemove(row.item)"
                        >
                          Remove
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </b-col>

              </b-row>
            </b-tab>

            <b-tab title="Crop Prices">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="cropping_season"><strong>Cropping Season</strong></label>
                    <b-form-select
                      id="cropping_season"
                      v-model="cropPrice.cropping_season"
                      :options="list.cropping_seasons"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- Please Select Cropping Season --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="cropping_year"><strong>Cropping Year</strong></label>
                    <b-form-select
                      id="cropping_year"
                      v-model="cropPrice.cropping_year"
                      :options="list.cropping_years"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- Please Select Cropping Year --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="crop"><strong>Crop</strong></label>
                    <b-form-select
                      id="crop"
                      v-model="cropPrice.crop"
                      :options="list.crops"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- Please Select Crop --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="selling_condition"><strong>Selling Condition</strong></label>
                    <b-form-select
                      id="selling_condition"
                      v-model="cropPrice.selling_condition"
                      :options="list.selling_conditions"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="null"
                          disabled
                        >
                          -- Please Select Selling State --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="total_harvested"><strong>Total Harvested (Bags / Sacks)</strong></label>
                    <b-input
                      id="total_harvested"
                      v-model="cropPrice.total_harvested"
                      type="number"
                      placeholder="enter total harvested"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="price"><strong>Selling Price</strong></label>
                    <b-input
                      id="price"
                      v-model="cropPrice.selling_price"
                      type="number"
                      placeholder="enter selling price"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-button
                    class="mr-2"
                    type="button"
                    :variant="cropPriceButtonVariant"
                    :disabled="cropPriceButtonDisabledState"
                    @click="onCropPriceButtonClick"
                  >
                    {{ cropPriceButtonLabel }}
                  </b-button>
                  <b-button
                    v-if="state.cropPriceEditing"
                    type="button"
                    variant="danger"
                    @click="onCropPriceCancelUpdate"
                  >
                    Cancel Update
                  </b-button>
                </b-col>

                <b-col
                  cols="12"
                  class="mt-2"
                >
                  <b-table
                    ref="table-crop-prices"
                    hover
                    responsive
                    show-empty
                    :fields="tableCropPrices.fields"
                    :items="filteredCustomerCropPrices"
                  >
                    <template #cell(index)="data">
                      {{ tableCropPrices.currentPage * tableCropPrices.perPage - tableCropPrices.perPage + (data.index + 1) }}
                    </template>

                    <template #cell()="data">
                      <div class="text-nowrap">
                        {{ data.value }}
                      </div>
                    </template>

                    <template #cell(actions)="row">
                      <div class="text-nowrap">
                        <b-button
                          size="sm"
                          variant="success"
                          :disabled="state.cropPriceEditing"
                          class="mr-2"
                          @click="onCropPriceEdit(row.item)"
                        >
                          Edit
                        </b-button>

                        <b-button
                          v-if="isNaN(parseInt(row.item.id))"
                          size="sm"
                          variant="danger"
                          :disabled="state.cropPriceEditing"
                          @click="onCropPriceRemove(row.item)"
                        >
                          Remove
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </b-col>

              </b-row>
            </b-tab>

            <b-tab
              title="Call Disposal"
            >
              <b-row>
                <b-col cols="12">
                  <b-table
                    ref="tableLog"
                    hover
                    responsive
                    class="mt-2"
                    :per-page="tableCallLogSettings.perPage"
                    :current-page="tableCallLogSettings.currentPage"
                    :items="myLogProvider"
                    :fields="tableCallLogSettings.fields"
                    :sort-by.sync="tableCallLogSettings.sortBy"
                    :sort-desc.sync="tableCallLogSettings.sortDesc"
                    :sort-direction="tableCallLogSettings.sortDirection"
                    :filter="tableCallLogSettings.filter"
                    :filter-included-fields="tableCallLogSettings.filterOn"
                    show-empty
                  >
                    <template #cell(index)="data">
                      {{ tableCallLogSettings.currentPage * tableCallLogSettings.perPage - tableCallLogSettings.perPage + (data.index + 1) }}
                    </template>

                    <template #cell()="data">
                      <div class="text-nowrap">
                        {{ data.value }}
                      </div>
                    </template>

                    <template #cell(actions)="row">
                      <div class="text-nowrap">
                        <b-button
                          size="sm"
                          variant="secondary"
                          class="mr-2"
                          @click="onViewRemarks(row.item)"
                        >
                          View
                        </b-button>
                      </div>
                    </template>

                  </b-table>

                  <b-row>
                    <b-col
                      cols="12"
                      sm="6"
                    >
                      <div class="w-100 w-sm-25 mb-2 sm-mb-2">
                        <b-select
                          v-model="tableCallLogSettings.perPage"
                          :options="tableCallLogSettings.pageOptions"
                          size="sm"
                        />
                      </div>
                    </b-col>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex justify-content-center justify-content-sm-end"
                    >
                      <b-pagination
                        v-model="tableCallLogSettings.currentPage"
                        :total-rows="tableCallLogSettings.totalRows"
                        :per-page="tableCallLogSettings.perPage"
                        first-number
                        last-number
                        pills
                        prev-text="Prev"
                        next-text="Next"
                        aria-controls="table"
                      />
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12">
                  <b-form-group>
                    <label><strong>Previous Remarks</strong></label>
                    <b-textarea
                      :value="allComments"
                      rows="10"
                      max-rows="10"
                      :disabled="true"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="call status"
                    vid="call_status"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="call_status"><strong>Call Status</strong></label>
                      <v-select
                        id="call_status"
                        v-model="selected.call_status"
                        :options="options.call_statuses"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="text"
                        :disabled="state.busy"
                        placeholder="-- Please Select Call Status --"
                      >
                        <template #option="{ text }">
                          <span>{{ text }}</span>
                        </template>
                        <template #no-options="">
                          No Available Call Statuses
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="unsuccessful reason"
                    vid="unsuccessful_reason"
                    :rules="rulesUnsuccessfulReason"
                  >
                    <b-form-group>
                      <label for="unsuccessful_reason"><strong>Unsuccessful Reason</strong></label>
                      <v-select
                        id="unsuccessful_reason"
                        v-model="selected.unsuccessful_reason"
                        :options="list.unsuccessful_reasons"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="reason_name"
                        :disabled="(state.busy || rawData.call_status !== 'Unsuccessful')"
                        placeholder="-- Please Select Unsuccessful Reason --"
                      >
                        <template #option="{ reason_name }">
                          <span>{{ reason_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Unsuccessful Reasons
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="disposition type"
                    vid="disposition_type"
                    :rules="rulesDispositionType"
                  >
                    <b-form-group>
                      <label for="disposition_type"><strong>Disposition Type</strong></label>
                      <v-select
                        id="disposition_type"
                        v-model="selected.disposition_type"
                        :options="list.disposition_types"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="type_name"
                        :disabled="(state.busy || rawData.call_status !== 'Connected')"
                        placeholder="-- Please Select Disposition Type --"
                      >
                        <template #option="{ type_name }">
                          <span>{{ type_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Disposition Types
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="disposition"
                    vid="disposition"
                    :rules="rulesDisposition"
                  >
                    <b-form-group>
                      <label for="sub_disposition"><strong>Disposition</strong></label>
                      <v-select
                        id="disposition"
                        v-model="selected.disposition"
                        :options="list.dispositions"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="disposition_name"
                        :disabled="(state.busy || rawData.call_status !== 'Connected')"
                        placeholder="-- Please Select Disposition --"
                      >
                        <template #option="{ disposition_name }">
                          <span>{{ disposition_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Dispositions
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="promotion"
                    vid="promotion"
                    :rules="rulesPromotion"
                  >
                    <b-form-group>
                      <label for="promotion"><strong>Promotion</strong></label>
                      <v-select
                        id="promotion"
                        v-model="selected.promotion"
                        :options="list.promotions"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="promotion_name"
                        :disabled="(state.busy || rawData.call_status !== 'Connected' || parseInt(rawData.disposition_type) !== 8)"
                        placeholder="-- Please Select Promotion --"
                      >
                        <template #option="{ promotion_name }">
                          <span>{{ promotion_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Promotions
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="marketing program"
                    vid="marketing_program"
                    rules=""
                  >
                    <b-form-group>
                      <label for="marketing_program"><strong>Marketing Program</strong></label>
                      <v-select
                        id="marketing_program"
                        v-model="selected.marketing_program"
                        :options="list.marketing_programs"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="marketing_program_name"
                        :disabled="(state.busy || rawData.call_status !== 'Connected')"
                        placeholder="-- Please Select Marketing Program --"
                      >
                        <template #option="{ marketing_program_name }">
                          <span>{{ marketing_program_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Marketing Programs
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="nps rate"
                    vid="satisfaction_rate"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="satisfaction_rate"><strong>Customer Satisfaction Rate</strong></label>
                      <b-form-select
                        id="satisfaction_rate"
                        v-model="rawData.satisfaction_rate"
                        :options="options.satisfaction_rates"
                        :state="errors.length > 0 ? false : null"
                        :disabled="(state.busy || rawData.call_status !== 'Connected')"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Satisfaction Rate --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col cols="12">
                  <ValidationProvider
                    #default="{ errors }"
                    name="remarks"
                    vid="remarks"
                    rules="required|max:1000"
                  >
                    <b-form-group>
                      <label for="remarks"><strong>Remarks</strong></label>
                      <b-textarea
                        id="remarks"
                        v-model="rawData.remarks"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter remarks"
                        autocomplete="off"
                        rows="6"
                        max-rows="6"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  class="mt-2 mb-2"
                >
                  <b-form-checkbox
                    id="for_visit"
                    v-model="rawData.for_visit"
                    name="for_visit"
                    value="1"
                    unchecked-value="0"
                    :disabled="(state.busy || rawData.province === null || rawData.municipality === null || rawData.barangay === null || rawData.call_status === null || rawData.call_status === 'Unsuccessful')"
                    switch
                  >
                    <strong>CUSTOMER NEEDS VISITATION?</strong>
                  </b-form-checkbox>
                </b-col>

                <b-col
                  v-if="parseInt(rawData.for_visit) === 1"
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="lead agent"
                    vid="lead_agent"
                    :rules="rulesLeadAgent"
                  >
                    <b-form-group>
                      <label for="lead_agent"><strong>Lead Agents</strong></label>
                      <v-select
                        id="lead_agent"
                        v-model="selected.lead_agent"
                        :options="filteredLeadAgents"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="full_name"
                        :disabled="state.busy"
                        placeholder="-- Please Select Lead Agent --"
                      >
                        <template #option="{ full_name }">
                          <span>{{ full_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Lead Agents
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  v-if="parseInt(rawData.for_visit) === 1"
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="ticket number"
                    vid="ticket_number"
                    :rules="rulesTicketNumber"
                  >
                    <b-form-group>
                      <label for="ticket_number"><strong>Ticket Number</strong></label>
                      <b-input
                        id="ticket_number"
                        v-model="rawData.ticket_number"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter ticket number"
                        autocomplete="off"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  v-if="parseInt(rawData.for_visit) === 1"
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="due date"
                    vid="due_date"
                    :rules="rulesTicketNumber"
                  >
                    <b-form-group>
                      <label for="due_date"><strong>Due Date</strong></label>
                      <b-input
                        id="due_date"
                        v-model="rawData.due_date"
                        type="date"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  v-if="parseInt(rawData.for_visit) === 1"
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="ticket category"
                    vid="ticket_category"
                    :rules="rulesTicketCategory"
                  >
                    <b-form-group>
                      <label for="ticket_category"><strong>Ticket Category</strong></label>
                      <v-select
                        id="ticket_category"
                        v-model="selected.ticket_category"
                        :options="list.ticket_categories"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="category_name"
                        :disabled="state.busy"
                        placeholder="-- Please Select Ticket Category --"
                      >
                        <template #option="{ category_name }">
                          <span>{{ category_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Ticket Categories
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  v-if="parseInt(rawData.for_visit) === 1"
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="visit remarks"
                    vid="visit_remarks"
                    :rules="rulesVisitationRemarks"
                  >
                    <b-form-group>
                      <label for="visit_remarks"><strong>Visit Remarks</strong></label>
                      <b-textarea
                        id="visit_remarks"
                        v-model="rawData.visit_remarks"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter visit remarks"
                        autocomplete="off"
                        rows="6"
                        max-rows="6"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  v-if="parseInt(rawData.for_visit) === 1"
                  cols="12"
                  class="mt-2 mb-5"
                >
                  <b-form-checkbox
                    id="sales_opportunity"
                    v-model="rawData.sales_opportunity"
                    name="sales_opportunity"
                    value="1"
                    unchecked-value="0"
                    :disabled="state.busy"
                    switch
                  >
                    <strong>MARK THIS VISIT AS SALES OPPORTUNITY?</strong>
                  </b-form-checkbox>
                </b-col>
              </b-row>

            </b-tab>
          </b-tabs>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="success"
          :disabled="(state.busy || state.cropHistoryEditing || state.cropDetailEditing || state.cropPriceEditing)"
          @click="ok()"
        >
          Save Record
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-view-remarks"
      title="View Details"
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Disposed At</label>
            <b-input
              :value="dateTimeFormatter(selected.log?.created_at)"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Agent</label>
            <b-input
              :value="selected.log?.agent_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Channel Name</label>
            <b-input
              :value="selected.log?.channel_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Call Status</label>
            <b-input
              :value="selected.log?.call_status"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
        >
          <b-form-group>
            <label>Unsuccessful Reason</label>
            <b-input
              :value="selected.log?.unsuccessful_reason_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Disposition Type</label>
            <b-input
              :value="selected.log?.disposition_type_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Disposition</label>
            <b-input
              :value="selected.log?.disposition_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
        >
          <b-form-group>
            <label>Promotion</label>
            <b-input
              :value="selected.log?.promotion_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <label>Remarks</label>
            <b-textarea
              :value="selected.log?.remarks"
              rows="10"
              max-rows="10"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="danger"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>
    </b-modal>

  </b-container>
</template>

<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AxiosError, AgentPendingDataService, AgentLogService, SharedListService } from '@/services'
import formatter from '@/mixins/formatter'
import misc from '@/mixins/misc'

export default {
  name: 'AgentPendingData',

  middleware: ['auth', 'agent'],

  mixins: [formatter, misc],

  metaInfo () {
    return {
      title: 'Pending Data'
    }
  },

  data () {
    return {
      state: {
        busy: false,
        editing: false,
        cropDetailEditing: false,
        cropHistoryEditing: false,
        cropPriceEditing: false
      },
      filter: {
        filter_cluster: 'all',
        filter_area: 'all',
        filter_call_status: 'all',
        filter_unsuccessful_reason: 'all'
      },
      list: {
        clusters: [],
        filter_clusters: [],
        areas: [],
        filter_areas: [],
        provinces: [],
        municipalities: [],
        barangays: [],
        promotions: [],
        marketing_programs: [],
        mode_of_communications: [],
        mode_of_payments: [],
        dealers: [],
        dialects: [],
        raisers: [],
        packages: [],
        custom_fields: [],
        cropping_seasons: [
          { text: 'Wet', value: 'Wet' },
          { text: 'Dry', value: 'Dry' }
        ],
        cropping_years: [
          { text: '2022', value: 2022 },
          { text: '2023', value: 2023 },
          { text: '2024', value: 2024 },
          { text: '2025', value: 2025 },
          { text: '2026', value: 2026 },
          { text: '2027', value: 2027 },
          { text: '2028', value: 2028 },
          { text: '2029', value: 2029 },
          { text: '2030', value: 2030 },
          { text: '2031', value: 2031 },
          { text: '2032', value: 2032 }
        ],
        selling_conditions: [
          { text: 'Dry', value: 'Dry' },
          { text: 'Fresh', value: 'Fresh' }
        ],
        crops: [],
        classifications: [],
        field_sizes: [],
        varieties: [],
        herbicides: [],
        fungicides: [],
        insecticides: [],
        fertilizers: [],
        unsuccessful_reasons: [],
        disposition_types: [],
        dispositions: [],
        lead_agents: [],
        ticket_categories: []
      },
      options: {
        genders: [
          { text: 'Male', value: 'Male' },
          { text: 'Female', value: 'Female' }
        ],
        customer_types: [
          { text: 'Farmer', value: 'Farmer' },
          { text: 'Non-Farmer', value: 'Non-Farmer' },
          { text: 'Dealer', value: 'Dealer' }
        ],
        schedules: [
          { text: 'Morning', value: 'Morning' },
          { text: 'Afternoon', value: 'Afternoon' },
          { text: 'Evening', value: 'Evening' }
        ],
        call_statuses: [
          { text: 'Connected', value: 'Connected' },
          { text: 'Unsuccessful', value: 'Unsuccessful' }
        ],
        satisfaction_rates: [
          { text: 0, value: 0 },
          { text: 1, value: 1 },
          { text: 2, value: 2 },
          { text: 3, value: 3 },
          { text: 4, value: 4 },
          { text: 5, value: 5 },
          { text: 6, value: 6 },
          { text: 7, value: 7 },
          { text: 8, value: 8 },
          { text: 9, value: 9 },
          { text: 10, value: 10 }
        ],
        filter_call_statuses: [
          { text: 'None', value: 'None' },
          { text: 'Connected', value: 'Connected' },
          { text: 'Unsuccessful', value: 'Unsuccessful' }
        ]
      },
      selected: {
        current: null,
        log: null,
        province: null,
        municipality: null,
        barangay: null,
        cluster: null,
        filter_cluster: null,
        area: null,
        filter_area: null,
        filter_call_status: null,
        call_status: null,
        unsuccessful_reason: null,
        filter_unsuccessful_reason: null,
        disposition_type: null,
        disposition: null,
        promotion: null,
        marketing_program: null,
        lead_agent: null,
        ticket_category: null
      },
      selected2: {
        current: null,
        cropping_season: null,
        cropping_year: null,
        crop: null,
        classification: null,
        varieties: null,
        herbicide_ones: null,
        herbicide_twos: null,
        fungicides: null,
        insecticides: null,
        fertilizers: null
      },
      rawData: {
        id: 0,
        first_name: '',
        last_name: '',
        mobile_number: '',
        email: '',
        customer_type: null,
        gender: null,
        birth_date: null,
        primary_dialect: null,
        secondary_dialect: null,
        experience: 0,
        number_of_household: 0,
        occupation: '',
        other_occupation: '',
        dealers: [],
        other_dealer: null,
        cluster: null,
        area: null,
        street_name: '',
        province: null,
        municipality: null,
        barangay: null,
        farm_address: '',
        mop: null,
        moc: null,
        preferred_time: null,
        raisers: [],
        packages: [],
        custom_fields: [],
        dirty_custom_fields: [],
        crop_details: [],
        dirty_crop_details: [],
        crop_histories: [],
        dirty_crop_histories: [],
        crop_prices: [],
        dirty_crop_prices: [],
        channel: 1,
        call_status: null,
        unsuccessful_reason: null,
        disposition_type: null,
        disposition: null,
        promotion: null,
        marketing_program: null,
        satisfaction_rate: 0,
        remarks: '',
        source_remarks: '',
        for_visit: 0,
        lead_agent: null,
        ticket_number: '',
        due_date: null,
        ticket_category: null,
        visit_remarks: '',
        sales_opportunity: 0
      },
      customField: {
        field: null,
        field_value: ''
      },
      cropDetail: {
        id: 0,
        active: 0,
        crop: null,
        crop_name: null,
        field_size: null,
        field_size_name: null,
        number_of_hectares: 0,
        created_at: null,
        updated_at: null
      },
      cropHistory: {
        id: 0,
        active: 0,
        cropping_season: null,
        cropping_year: null,
        crop: null,
        crop_name: null,
        classification: null,
        classification_name: null,
        varieties: [],
        variety_names: null,
        herbicide_ones: [],
        herbicide_one_names: null,
        herbicide_twos: [],
        herbicide_two_names: null,
        fungicides: [],
        fungicide_names: null,
        insecticides: [],
        insecticide_names: null,
        fertilizers: [],
        fertilizer_names: null,
        bag_per_ha: 0
      },
      cropPrice: {
        id: 0,
        active: 0,
        cropping_season: null,
        cropping_year: null,
        crop: null,
        total_harvested: 0,
        selling_condition: null,
        selling_price: 0
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'first_name', sortable: true },
          { key: 'last_name', sortable: true },
          { key: 'mobile_number' },
          { key: 'submitted_by' },
          { key: 'last_call_status', label: 'last status' },
          { key: 'last_call', formatter: this.dateTimeFormatterLong, sortable: true },
          { key: 'last_agent_name', label: 'last agent' },
          { key: 'logs_count', label: 'unsuccessful call' },
          { key: 'unsuccessful_reason_name', label: 'last unsuccessful reason' },
          { key: 'updated_at', formatter: this.dateTimeFormatter }
        ]
      },
      tableCropDetails: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: true,
        sortDirection: 'desc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'crop_name', label: 'Crop' },
          { key: 'field_size_name', label: 'Field Size' },
          { key: 'number_of_hectares', label: 'Number of Hectares' },
          { key: 'updated_at', formatter: this.dateTimeFormatter }
        ]
      },
      tableCropHistories: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: true,
        sortDirection: 'desc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'cropping_season' },
          { key: 'cropping_year' },
          { key: 'crop_name' },
          { key: 'classification_name' },
          { key: 'variety_names' },
          { key: 'herbicide_one_names' },
          { key: 'herbicide_two_names' },
          { key: 'fungicide_names' },
          { key: 'insecticide_names' },
          { key: 'fertilizer_names' },
          { key: 'bag_per_ha', label: 'Bag Per Hectare' },
          { key: 'updated_at', formatter: this.dateTimeFormatter }
        ]
      },
      tableCropPrices: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: true,
        sortDirection: 'desc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'cropping_season' },
          { key: 'cropping_year' },
          { key: 'crop_name' },
          { key: 'total_harvested' },
          { key: 'selling_condition' },
          { key: 'selling_price' },
          { key: 'updated_at', formatter: this.dateTimeFormatter }
        ]
      },
      tableCallLogSettings: {
        perPage: 5,
        pageOptions: [5, 10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: true,
        sortDirection: 'desc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'agent_name', label: 'agent' },
          { key: 'call_status' },
          { key: 'unsuccessful_reason_name', label: 'unsuccessful reason' },
          { key: 'disposition_type_name', label: 'disposition type' },
          { key: 'disposition_name', label: 'disposition' },
          { key: 'promotion_name', label: 'promotion' }
        ]
      },
      allComments: ''
    }
  },

  computed: {
    filteredLeadAgents () {
      return this.list.lead_agents.filter(item => {
        // const provinceIds = item.provinces?.map(item => {
        //   return item.id
        // })

        // const municipalityIds = item.municipalities?.map(item => {
        //   return item.id
        // })

        // let condition = provinceIds?.includes(this.rawData.province)

        // if (municipalityIds?.length > 0) {
        //   condition = provinceIds?.includes(this.rawData.province) &&
        //     municipalityIds?.includes(this.rawData.municipality)
        // }

        // return condition

        return true
      })
    },

    filterUnsuccessfulReasons () {
      return this.list.unsuccessful_reasons
    },

    rulesCustomerType () {
      if (this.rawData.call_status === 'Connected') {
        return 'required'
      }

      return ''
    },

    rulesUnsuccessfulReason () {
      if (this.rawData.call_status === 'Unsuccessful') {
        return 'required'
      }

      return ''
    },

    rulesDispositionType () {
      if (this.rawData.call_status === 'Connected') {
        return 'required'
      }

      return ''
    },

    rulesDisposition () {
      if (this.rawData.call_status === 'Connected') {
        return 'required'
      }

      return ''
    },

    rulesPromotion () {
      if (this.rawData.call_status === 'Connected' && parseInt(this.rawData.disposition_type) === 8) {
        return 'required'
      }

      return ''
    },

    rulesLeadAgent () {
      if (parseInt(this.rawData.for_visit) === 1) {
        return 'required'
      }

      return ''
    },

    rulesTicketNumber () {
      if (parseInt(this.rawData.for_visit) === 1) {
        return 'required|max:10'
      }

      return 'max:10'
    },

    rulesTicketCategory () {
      if (parseInt(this.rawData.for_visit) === 1) {
        return 'required'
      }

      return ''
    },

    rulesVisitationRemarks () {
      if (parseInt(this.rawData.for_visit) === 1) {
        return 'required|max:1000'
      }

      return ''
    },

    filteredCustomerCropDetails () {
      return this.rawData.crop_details.filter(item => item.active === 1)
    },

    cropDetailButtonLabel () {
      if (this.state.cropDetailEditing) {
        return 'Update Detail'
      }

      return 'Insert Detail'
    },

    cropDetailButtonVariant () {
      if (this.state.cropDetailEditing) {
        return 'secondary'
      }

      return 'success'
    },

    cropDetailButtonDisabledState () {
      return !(this.cropDetail.crop && this.cropDetail.field_size && parseFloat(this.cropDetail.number_of_hectares) > 0)
    },

    filteredCustomerCropHistories () {
      return this.rawData.crop_histories.filter(item => item.active === 1)
    },

    cropHistoryButtonLabel () {
      if (this.state.cropHistoryEditing) {
        return 'Update Detail'
      }

      return 'Insert Detail'
    },

    cropHistoryButtonVariant () {
      if (this.state.cropHistoryEditing) {
        return 'secondary'
      }

      return 'success'
    },

    cropHistoryButtonDisabledState () {
      return !(this.cropHistory.cropping_season && this.cropHistory.cropping_year && this.cropHistory.crop)
    },

    filteredCustomerCropPrices () {
      return this.rawData.crop_prices.filter(item => item.active === 1)
    },

    cropPriceButtonLabel () {
      if (this.state.cropPriceEditing) {
        return 'Update Detail'
      }

      return 'Insert Detail'
    },

    cropPriceButtonVariant () {
      if (this.state.cropPriceEditing) {
        return 'secondary'
      }

      return 'success'
    },

    cropPriceButtonDisabledState () {
      return !(this.cropPrice.cropping_season && this.cropPrice.cropping_year && this.cropPrice.crop && this.cropPrice.selling_condition && parseFloat(this.cropPrice.selling_price) > 0)
    },

    customFieldInserButttonDisabledState () {
      return !(this.customField.field && this.customField.field_value.length > 0)
    }
  },

  watch: {
    'selected.province' (value) {
      this.rawData.province = value?.id || null
      this.getMunicipalities(this.rawData.province)
    },

    'selected.municipality' (value) {
      this.rawData.municipality = value?.id || null
      this.getBarangays(this.rawData.municipality)
    },

    'selected.barangay' (value) {
      this.rawData.barangay = value?.id || null
    },

    'selected.cluster' (value) {
      this.rawData.cluster = value?.id || null
      this.getAreas(this.rawData.cluster)
    },

    'selected.area' (value) {
      this.rawData.area = value?.id || null
    },

    'selected.call_status' (value) {
      this.rawData.call_status = value?.value || null
      if (!this.rawData.call_status) {
        this.selected.unsuccessful_reason = null
        this.selected.disposition_type = null
        this.selected.disposition = null
        this.selected.promotion = null
        this.selected.marketing_program = null
        this.rawData.satisfaction_rate = 0
        this.rawData.for_visit = 0
      }

      if (this.rawData.call_status === 'Connected') {
        this.selected.unsuccessful_reason = null
      }

      if (this.rawData.call_status === 'Unsuccessful') {
        this.selected.disposition_type = null
        this.selected.disposition = null
        this.selected.promotion = null
        this.selected.marketing_program = null
        this.rawData.satisfaction_rate = 0
        this.rawData.for_visit = 0
      }
    },

    'selected.unsuccessful_reason' (value) {
      this.rawData.unsuccessful_reason = value?.id || null
    },

    'selected.disposition_type' (value) {
      this.rawData.disposition_type = value?.id || null
      if (parseInt(this.rawData.disposition_type) !== 8) {
        this.selected.promotion = null
      }
      this.getDispositions(this.rawData.disposition_type)
    },

    'selected.disposition' (value) {
      this.rawData.disposition = value?.id || null
    },

    'selected.promotion' (value) {
      this.rawData.promotion = value?.id || null
    },

    'selected.marketing_program' (value) {
      this.rawData.marketing_program = value?.id || null
    },

    'selected.lead_agent' (value) {
      this.rawData.lead_agent = value?.id || null
    },

    'selected.ticket_category' (value) {
      this.rawData.ticket_category = value?.id || null
    },

    'selected.filter_cluster' (value) {
      this.filter.filter_cluster = value?.id || 'all'
      this.getFilterAreas(value?.id || null)
      this.onFilterChanged()
    },

    'selected.filter_area' (value) {
      this.filter.filter_area = value?.id || 'all'
      this.onFilterChanged()
    },

    'selected.filter_call_status' (value) {
      this.filter.filter_call_status = value?.value || 'all'
      this.onFilterChanged()
    },

    'selected.filter_unsuccessful_reason' (value) {
      this.filter.filter_unsuccessful_reason = value?.id || 'all'
      this.onFilterChanged()
    },

    'selected2.cropping_season' (value) {
      this.cropHistory.cropping_season = value?.value || null
    },

    'selected2.cropping_year' (value) {
      this.cropHistory.cropping_year = value?.value || null
    },

    'selected2.crop' (value) {
      this.cropHistory.crop = value?.value || null
      this.getClassifications(this.cropHistory.crop)
      this.getVarieties(this.cropHistory.crop)
      this.getHerbicides(this.cropHistory.crop)
      this.getFungicides(this.cropHistory.crop)
      this.getInsecticides(this.cropHistory.crop)
      this.getFertilizers(this.cropHistory.crop)
    },

    'selected2.classification' (value) {
      this.cropHistory.classification = value?.id || null
    },

    'selected2.varieties' (value) {
      this.cropHistory.varieties = value
    },

    'selected2.herbicide_ones' (value) {
      this.cropHistory.herbicide_ones = value
    },

    'selected2.herbicide_twos' (value) {
      this.cropHistory.herbicide_twos = value
    },

    'selected2.fungicides' (value) {
      this.cropHistory.fungicides = value
    },

    'selected2.insecticides' (value) {
      this.cropHistory.insecticides = value
    },

    'selected2.fertilizers' (value) {
      this.cropHistory.fertilizers = value
    },

    'rawData.for_visit' (value) {
      if (parseInt(value) === 0) {
        this.selected.lead_agent = null
        this.rawData.ticket_number = ''
        this.rawData.due_date = null
        this.selected.ticket_category = null
        this.rawData.visit_remarks = ''
        this.rawData.sales_opportunity = 0
      }
    }
  },

  mounted () {
    core.index()
    this.getClusters()
    this.getFilterClusters()
    this.getProvinces()
    this.getModeOfPayments()
    this.getModeOfCommunications()
    this.getDialects()
    this.getDealers()
    this.getCrops()
    this.getFieldSizes()
    this.getUnsuccessfulReasons()
    this.getDispositionTypes()
    this.getPromotions()
    this.getMarketingPrograms()
    this.getCustomFields()
    this.getRaisers()
    this.getLeadAgents()
    this.getTicketCategories()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await AgentPendingDataService.get(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_cluster: this.filter.filter_cluster,
            filter_area: this.filter.filter_area,
            filter_call_status: this.filter.filter_call_status,
            filter_unsuccessful_reason: this.filter.filter_unsuccessful_reason,
            filter_text: ctx.filter
          })
        )
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async myLogProvider (ctx) {
      try {
        const { data } = await AgentLogService.getRawDataLogs(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_text: ctx.filter,
            raw_id: this.rawData.id
          })
        )
        this.tableCallLogSettings.totalRows = data.total_rows
        this.allComments = ''
        data.items.forEach(log => {
          const remarks = `${this.dateTimeFormatterLong(log.created_at)} [${log.agent_name} thru ${log.channel_name}]: ${log.remarks}\r\n\r\n`
          this.allComments += remarks
        })
        return data.items
      } catch {
        return []
      }
    },

    async getProvinces () {
      await SharedListService.getProvinces().then(({ data }) => {
        this.list.provinces = data
      })
    },

    async getMunicipalities (province) {
      this.selected.municipality = null
      if (province) {
        await SharedListService.getMunicipalities(`province_id=${province}`).then(({ data }) => {
          this.list.municipalities = data

          if (this.state.editing) {
            if (this.selected.current.municipality) {
              this.selected.municipality = {
                id: this.selected.current.municipality.id,
                municipality_name: this.selected.current.municipality.municipality_name
              }
              this.selected.current.municipality = null
            }
          }
        })
      } else {
        this.list.municipalities = []
      }
    },

    async getBarangays (municipality) {
      this.selected.barangay = null
      if (municipality) {
        await SharedListService.getBarangays(`municipality_id=${municipality}`).then(({ data }) => {
          this.list.barangays = data

          if (this.state.editing) {
            if (this.selected.current.barangay) {
              this.selected.barangay = {
                id: this.selected.current.barangay.id,
                barangay_name: this.selected.current.barangay.barangay_name
              }
              this.selected.current.barangay = null
            }
          }
        })
      } else {
        this.list.barangays = []
      }
    },

    async getClusters () {
      await SharedListService.getClusters().then(({ data }) => {
        this.list.clusters = data
      })
    },

    async getAreas (cluster) {
      this.selected.area = null
      if (cluster) {
        await SharedListService.getAreas(`cluster_id=${cluster}`).then(({ data }) => {
          this.list.areas = data

          if (this.state.editing) {
            if (this.selected.current.area) {
              this.selected.area = {
                id: this.selected.current.area.id,
                area_name: this.selected.current.area.area_name
              }
              this.selected.current.area = null
            }
          }
        })
      } else {
        this.list.areas = []
      }
    },

    async getFilterClusters () {
      await SharedListService.getClusters().then(({ data }) => {
        this.list.filter_clusters = data
      })
    },

    async getFilterAreas (cluster) {
      this.selected.filter_area = null
      if (cluster) {
        await SharedListService.getAreas(`cluster_id=${cluster}`).then(({ data }) => {
          this.list.filter_areas = data
        })
      } else {
        this.list.filter_areas = []
      }
    },

    async getModeOfCommunications () {
      await SharedListService.getModeOfCommunications().then(({ data }) => {
        this.list.mode_of_communications = data.map(item => {
          return {
            text: item.moc_name,
            value: item.id
          }
        })
      })
    },

    async getModeOfPayments () {
      await SharedListService.getModeOfPayments().then(({ data }) => {
        this.list.mode_of_payments = data.map(item => {
          return {
            text: item.mop_name,
            value: item.id
          }
        })
      })
    },

    async getDealers () {
      await SharedListService.getDealers().then(({ data }) => {
        this.list.dealers = data
      })
    },

    async getRaisers () {
      await SharedListService.getRaisers().then(({ data }) => {
        this.list.raisers = data
      })
    },

    async getDialects () {
      await SharedListService.getDialects().then(({ data }) => {
        this.list.dialects = data.map(item => {
          return {
            text: item.dialect_name,
            value: item.id
          }
        })
      })
    },

    async getCustomFields () {
      await SharedListService.getCustomFields().then(({ data }) => {
        this.list.custom_fields = data.map(item => {
          return {
            text: item.field_label,
            value: item.id
          }
        })
      })
    },

    async getCrops () {
      await SharedListService.getCrops().then(({ data }) => {
        this.list.crops = data.map(item => {
          return {
            text: item.crop_name,
            value: item.id
          }
        })
      })
    },

    async getClassifications (crop) {
      this.selected2.classification = null
      if (crop) {
        await SharedListService.getClassifications(`crop=${crop}`).then(({ data }) => {
          this.list.classifications = data
          if (this.state.cropHistoryEditing) {
            if (this.selected2.current.classification) {
              this.selected2.classification = _.find(this.list.classifications, { id: this.selected2.current.classification })
              this.selected2.current.classification = null
            }
          }
        })
      } else {
        this.list.classifications = []
      }
    },

    async getVarieties (crop) {
      this.selected2.varieties = null
      if (crop) {
        await SharedListService.getVarieties(`crop=${crop}`).then(({ data }) => {
          this.list.varieties = data
          if (this.state.cropHistoryEditing) {
            if (this.selected2.current.varieties) {
              this.selected2.varieties = this.selected2.current.varieties
              this.selected2.current.varieties = null
            }
          }
        })
      } else {
        this.list.varieties = []
      }
    },

    async getHerbicides (crop) {
      this.selected2.herbicide_ones = null
      this.selected2.herbicide_twos = null
      if (crop) {
        await SharedListService.getHerbicides(`crop=${crop}`).then(({ data }) => {
          this.list.herbicides = data
          if (this.state.cropHistoryEditing) {
            if (this.selected2.current.herbicide_ones) {
              this.selected2.herbicide_ones = this.selected2.current.herbicide_ones
              this.selected2.current.herbicide_ones = null
            }
            if (this.selected2.current.herbicide_twos) {
              this.selected2.herbicide_twos = this.selected2.current.herbicide_twos
              this.selected2.current.herbicide_twos = null
            }
          }
        })
      } else {
        this.list.herbicides = []
      }
    },

    async getFungicides (crop) {
      this.selected2.fungicides = null
      if (crop) {
        await SharedListService.getFungicides(`crop=${crop}`).then(({ data }) => {
          this.list.fungicides = data
          if (this.state.cropHistoryEditing) {
            if (this.selected2.current.fungicides) {
              this.selected2.fungicides = this.selected2.current.fungicides
              this.selected2.current.fungicides = null
            }
          }
        })
      } else {
        this.list.fungicides = []
      }
    },

    async getInsecticides (crop) {
      this.selected2.insecticides = null
      if (crop) {
        await SharedListService.getInsecticides(`crop=${crop}`).then(({ data }) => {
          this.list.insecticides = data
          if (this.state.cropHistoryEditing) {
            if (this.selected2.current.insecticides) {
              this.selected2.insecticides = this.selected2.current.insecticides
              this.selected2.current.insecticides = null
            }
          }
        })
      } else {
        this.list.insecticides = []
      }
    },

    async getFertilizers (crop) {
      this.selected2.fertilizers = null
      if (crop) {
        await SharedListService.getFertilizers(`crop=${crop}`).then(({ data }) => {
          this.list.fertilizers = data
          if (this.state.cropHistoryEditing) {
            if (this.selected2.current.fertilizers) {
              this.selected2.fertilizers = this.selected2.current.fertilizers
              this.selected2.current.fertilizers = null
            }
          }
        })
      } else {
        this.list.fertilizers = []
      }
    },

    async getFieldSizes () {
      await SharedListService.getFieldSizes().then(({ data }) => {
        this.list.field_sizes = data.map(item => {
          return {
            text: item.field_size_name,
            value: item.id
          }
        })
      })
    },

    async getUnsuccessfulReasons () {
      await SharedListService.getUnsuccessfulReasons().then(({ data }) => {
        this.list.unsuccessful_reasons = data
      })
    },

    async getDispositionTypes () {
      await SharedListService.getDispositionTypes(`channel_id=${this.rawData.channel}`).then(({ data }) => {
        const filter = [3, 6, 18]
        this.list.disposition_types = data.filter(item => {
          return !filter.includes(item.id)
        })
      })
    },

    async getDispositions (dispositionType) {
      this.selected.disposition = null
      if (dispositionType) {
        await SharedListService.getDispositions(`disposition_type_id=${dispositionType}`).then(({ data }) => {
          this.list.dispositions = data
        })
      } else {
        this.list.dispositions = []
      }
    },

    async getPromotions () {
      await SharedListService.getPromotions().then(({ data }) => {
        this.list.promotions = data
      })
    },

    async getMarketingPrograms () {
      await SharedListService.getMarketingPrograms().then(({ data }) => {
        this.list.marketing_programs = data
      })
    },

    async getLeadAgents () {
      await SharedListService.getLeadAgents().then(({ data }) => {
        this.list.lead_agents = data
      })
    },

    async getTicketCategories () {
      await SharedListService.getTicketCategories().then(({ data }) => {
        this.list.ticket_categories = data
      })
    },

    onShowEditForm (current) {
      this.state.editing = true
      this.selected.current = { ...current }
      this.selected.cluster = null
      this.selected.province = null
      this.selected.call_status = null
      this.selected.unsuccessful_reason = null
      this.selected.disposition_type = null
      this.selected.disposition = null
      this.selected.promotion = null
      this.selected.marketing_program = null
      this.selected.lead_agent = null
      this.rawData.id = current.id
      this.rawData.active = current.active
      this.rawData.first_name = current.first_name
      this.rawData.last_name = current.last_name
      this.rawData.customer_type = null
      this.rawData.mobile_number = current.mobile_number
      this.rawData.email = current.email
      this.rawData.birth_date = null
      this.rawData.gender = null
      this.rawData.experience = 0
      this.rawData.number_of_household = 0
      this.rawData.primary_dialect = null
      this.rawData.secondary_dialect = null
      this.rawData.occupation = ''
      this.rawData.other_occupation = ''
      this.rawData.dealers = []
      this.rawData.other_dealer = null
      this.rawData.cluster = current.cluster_id
      this.rawData.area = current.area_id
      this.rawData.street_name = current.street_name
      this.rawData.province = null
      this.rawData.municipality = null
      this.rawData.barangay = null
      this.rawData.farm_address = current.farm_address
      this.rawData.moc = null
      this.rawData.mop = null
      this.rawData.preferred_time = null
      this.rawData.raisers = []
      this.rawData.packages = []
      this.rawData.custom_fields = []
      this.rawData.dirty_custom_fields = []
      this.rawData.dirty_crop_details = []
      this.rawData.crop_histories = []
      this.rawData.dirty_crop_histories = []
      this.rawData.crop_prices = []
      this.rawData.dirty_crop_prices = []
      this.rawData.satisfaction_rate = 0
      this.rawData.remarks = ''
      this.rawData.source_remarks = current.remarks
      this.rawData.for_visit = 0
      this.rawData.ticket_number = ''
      this.rawData.due_date = null
      this.rawData.visit_remarks = ''
      this.rawData.sales_opportunity = 0

      if (current.crops) {
        this.rawData.crop_details = current.crops.sort((a, b) => Number(a.order) - Number(b.order)).map(crop => ({
          id: crop.order,
          active: 1,
          crop: crop.crop_id,
          crop_name: crop.crop_name,
          other_crop_name: null,
          field_size: crop.crop_field_size_id,
          field_size_name: crop.crop_field_size_name,
          number_of_hectares: crop.number_of_hectares,
          created_at: current.created_at,
          updated_at: current.updated_at
        }))
      } else {
        this.rawData.crop_details = []
      }

      if (current.cluster) {
        this.selected.cluster = {
          id: current.cluster.id,
          cluster_name: current.cluster.cluster_name
        }
      }

      if (current.province) {
        this.selected.province = {
          id: current.province.id,
          province_name: current.province.province_name
        }
      }

      // reset state
      this.state.cropDetailEditing = false
      this.state.cropHistoryEditing = false
      this.state.cropPriceEditing = false

      // reset details
      this.onCustomFieldReset()
      this.onCropDetailReset()
      this.onCropHistoryReset()
      this.onCropPriceReset()

      this.$bvModal.show('modal-process-form')
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          const title = 'Do you really want to save?'
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: title,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              return this.onFormPostSubmit()
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk('Oops! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            centered: true
          })
        }
      })
    },

    async onFormPostSubmit () {
      return new Promise(resolve => {
        this.state.busy = true
        AgentPendingDataService.post(this.rawData)
          .then(({ data }) => {
            this.state.busy = false
            this.$bvModal.hide('modal-process-form')
            this.$swal
              .fire({
                icon: 'success',
                title: 'Successful',
                text: data.message,
                confirmButtonColor: '#06C270',
                confirmButtonText: 'Dismiss'
              })
              .then(() => {
                this.$refs.table.refresh()
              })
          })
          .catch(error => {
            this.state.busy = false
            if (error instanceof AxiosError) {
              if (error.code === 422) {
                this.$bvModal.msgBoxOk('Oops! There were problem with your inputs.', {
                  title: 'Validation Error',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  centered: true
                })
                this.$refs.form.setErrors(error.message)
                resolve(error)
              }
            }
          })
      })
    },

    onCustomFieldReset () {
      this.customField.field = null
      this.customField.field_value = ''
    },

    async onCustomFieldRefresh () {
      this.getCustomFields()
    },

    async onCustomFieldInsert () {
      this.rawData.custom_fields.push({
        id: this.generateId(10),
        field: this.customField.field,
        field_label: _.find(this.list.custom_fields, { value: this.customField.field })?.text || null,
        field_value: this.customField.field_value
      })

      this.onCustomFieldReset()
    },

    async onCustomFieldRemove (current) {
      if (!isNaN(parseInt(current.id))) {
        return
      }

      this.rawData.custom_fields = _.remove(this.rawData.custom_fields, function (o) {
        return o.id.toString() !== current.id.toString()
      })
    },

    onCropDetailReset () {
      this.cropDetail.id = 0
      this.cropDetail.active = 0
      this.cropDetail.crop = null
      this.cropDetail.crop_name = null
      this.cropDetail.field_size = null
      this.cropDetail.field_size_name = null
      this.cropDetail.number_of_hectares = 0
      this.cropDetail.created_at = null
      this.cropDetail.updated_at = null
    },

    onCropDetailButtonClick () {
      if (this.state.cropDetailEditing) {
        this.onCropDetailUpdate()
        return
      }

      this.onCropDetailInsert()
    },

    onCropDetailInsert () {
      if (!(this.cropDetail.crop && this.cropDetail.field_size && parseFloat(this.cropDetail.number_of_hectares) > 0)) {
        return
      }

      const newId = this.generateId(10)

      const crop = _.find(this.list.crops, { value: this.cropDetail.crop })
      const fieldSize = _.find(this.list.field_sizes, { value: this.cropDetail.field_size })

      this.cropDetail.id = newId
      this.cropDetail.active = 1
      this.cropDetail.crop_name = crop?.text
      this.cropDetail.field_size_name = fieldSize?.text

      this.rawData.crop_details.push({
        ...this.cropDetail
      })

      this.onCropDetailReset()
    },

    onCropDetailEdit (current) {
      this.state.cropDetailEditing = true
      this.cropDetail.id = current.id
      this.cropDetail.active = current.active
      this.cropDetail.crop = current.crop
      this.cropDetail.crop_name = current.crop_name
      this.cropDetail.field_size = current.field_size
      this.cropDetail.field_size_name = current.field_size_name
      this.cropDetail.number_of_hectares = current.number_of_hectares
    },

    onCropDetailUpdate () {
      const cropDetail = _.find(this.rawData.crop_details, { id: this.cropDetail.id })
      const crop = _.find(this.list.crops, { value: this.cropDetail.crop })
      const fieldSize = _.find(this.list.field_sizes, { value: this.cropDetail.field_size })

      this.cropDetail.crop_name = crop?.text
      this.cropDetail.field_size_name = fieldSize?.text

      if (cropDetail) {
        cropDetail.crop = this.cropDetail.crop
        cropDetail.crop_name = this.cropDetail.crop_name
        cropDetail.field_size = this.cropDetail.field_size
        cropDetail.field_size_name = this.cropDetail.field_size_name
        cropDetail.number_of_hectares = this.cropDetail.number_of_hectares
        // add to dirty list
        if (_.indexOf(this.rawData.dirty_crop_details, this.cropDetail.id) < 0) {
          this.rawData.dirty_crop_details.push(this.cropDetail.id)
        }
        this.state.cropDetailEditing = false
        this.onCropDetailReset()
      }
    },

    onCropDetailCancelUpdate () {
      this.state.cropDetailEditing = false
      this.onCropDetailReset()
    },

    onCropDetailRemove (current) {
      if (!isNaN(parseInt(current.id))) {
        return
      }

      const cropDetail = _.find(this.rawData.crop_details, { id: current.id })
      cropDetail.active = 0
    },

    onCropHistoryReset () {
      this.cropHistory.id = 0
      this.cropHistory.active = 0
      this.selected2.cropping_season = null
      this.selected2.cropping_year = null
      this.selected2.crop = null
      this.selected2.classification = null
      this.cropHistory.crop_name = null
      this.cropHistory.classification_name = null
      this.selected2.varieties = []
      this.selected2.herbicide_ones = []
      this.selected2.herbicide_twos = []
      this.selected2.fungicides = []
      this.selected2.insecticides = []
      this.selected2.fertilizers = []
    },

    onCropHistoryButtonClick () {
      if (this.state.cropHistoryEditing) {
        this.onCropHistoryUpdate()
        return
      }

      this.onCropHistoryInsert()
    },

    onCropHistoryInsert () {
      if (!(this.cropHistory.cropping_season && this.cropHistory.cropping_year && this.cropHistory.crop)) {
        return
      }

      const newId = this.generateId(10)

      const history = _.find(this.rawData.crop_histories, {
        cropping_season: this.cropHistory.cropping_season,
        cropping_year: this.cropHistory.cropping_year,
        crop: this.cropHistory.crop
      })

      if (history) {
        this.$bvModal.msgBoxOk('Oops! Crop history already exists.', {
          title: 'Validation Error',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          centered: true
        })
        return
      }

      const crop = _.find(this.list.crops, { value: this.cropHistory.crop })
      const classification = _.find(this.list.classifications, { id: this.cropHistory.classification })

      this.cropHistory.id = newId
      this.cropHistory.active = 1
      this.cropHistory.crop_name = crop?.text
      this.cropHistory.classification_name = classification?.classification_name
      this.cropHistory.variety_names = this.cropHistory.varieties ? this.cropHistory.varieties.map(s => s.variety_name).toString() : null
      this.cropHistory.herbicide_one_names = this.cropHistory.herbicide_ones ? this.cropHistory.herbicide_ones.map(s => s.herbicide_name).toString() : null
      this.cropHistory.herbicide_two_names = this.cropHistory.herbicide_twos ? this.cropHistory.herbicide_twos.map(s => s.herbicide_name).toString() : null
      this.cropHistory.fungicide_names = this.cropHistory.fungicides ? this.cropHistory.fungicides.map(s => s.fungicide_name).toString() : null
      this.cropHistory.insecticide_names = this.cropHistory.insecticides ? this.cropHistory.insecticides.map(s => s.insecticide_name).toString() : null
      this.cropHistory.fertilizer_names = this.cropHistory.fertilizers ? this.cropHistory.fertilizers.map(s => s.fertilizer_name).toString() : null

      this.rawData.crop_histories.push({
        ...this.cropHistory
      })

      this.onCropHistoryReset()
    },

    onCropHistoryEdit (current) {
      this.selected2.current = { ...current }
      this.state.cropHistoryEditing = true
      this.cropHistory.id = current.id
      this.cropHistory.active = current.active
      this.selected2.cropping_season = _.find(this.list.cropping_seasons, { value: current.cropping_season })
      this.selected2.cropping_year = _.find(this.list.cropping_years, { value: current.cropping_year })
      this.selected2.crop = _.find(this.list.crops, { value: current.crop })
    },

    onCropHistoryUpdate () {
      const cropHistory = _.find(this.rawData.crop_histories, { id: this.cropHistory.id })
      const crop = _.find(this.list.crops, { value: this.cropHistory.crop })
      const classification = _.find(this.list.classifications, { id: this.cropHistory.classification })

      this.cropHistory.crop_name = crop?.text
      this.cropHistory.classification_name = classification?.classification_name

      if (cropHistory) {
        cropHistory.cropping_season = this.cropHistory.cropping_season
        cropHistory.cropping_year = this.cropHistory.cropping_year
        cropHistory.crop = this.cropHistory.crop
        cropHistory.crop_name = this.cropHistory.crop_name
        cropHistory.classification = this.cropHistory.classification
        cropHistory.classification_name = this.cropHistory.classification_name
        cropHistory.varieties = this.cropHistory.varieties
        cropHistory.variety_names = this.cropHistory.varieties ? this.cropHistory.varieties.map(s => s.variety_name).toString() : null
        cropHistory.herbicide_ones = this.cropHistory.herbicide_ones
        cropHistory.herbicide_one_names = this.cropHistory.herbicide_ones ? this.cropHistory.herbicide_ones.map(s => s.herbicide_name).toString() : null
        cropHistory.herbicide_twos = this.cropHistory.herbicide_twos
        cropHistory.herbicide_two_names = this.cropHistory.herbicide_twos ? this.cropHistory.herbicide_twos.map(s => s.herbicide_name).toString() : null
        cropHistory.fungicides = this.cropHistory.fungicides
        cropHistory.fungicide_names = this.cropHistory.fungicides ? this.cropHistory.fungicides.map(s => s.fungicide_name).toString() : null
        cropHistory.insecticides = this.cropHistory.insecticides
        cropHistory.insecticide_names = this.cropHistory.insecticides ? this.cropHistory.insecticides.map(s => s.insecticide_name).toString() : null
        cropHistory.fertilizers = this.cropHistory.fertilizers
        cropHistory.fertilizer_names = this.cropHistory.fertilizers ? this.cropHistory.fertilizers.map(s => s.fertilizer_name).toString() : null
        cropHistory.bag_per_ha = this.cropHistory.bag_per_ha

        // add to dirty list
        if (_.indexOf(this.rawData.dirty_crop_histories, this.cropHistory.id) < 0) {
          this.rawData.dirty_crop_histories.push(this.cropHistory.id)
        }
        this.state.cropHistoryEditing = false
        this.onCropHistoryReset()
      }
    },

    onCropHistoryCancelUpdate () {
      this.state.cropHistoryEditing = false
      this.onCropHistoryReset()
    },

    onCropHistoryRemove (current) {
      if (!isNaN(parseInt(current.id))) {
        return
      }

      this.rawData.crop_histories = _.remove(this.rawData.crop_histories, function (o) {
        return o.id.toString() !== current.id.toString()
      })
    },

    onCropPriceReset () {
      this.cropPrice.id = 0
      this.cropPrice.active = 0
      this.cropPrice.cropping_season = null
      this.cropPrice.cropping_year = null
      this.cropPrice.crop = null
      this.cropPrice.total_harvested = 0
      this.cropPrice.selling_condition = null
      this.cropPrice.selling_price = 0
    },

    onCropPriceButtonClick () {
      if (this.state.cropPriceEditing) {
        this.onCropPriceUpdate()
        return
      }

      this.onCropPriceInsert()
    },

    onCropPriceInsert () {
      if (!(this.cropPrice.cropping_season && this.cropPrice.cropping_year && this.cropPrice.crop && this.cropPrice.selling_condition && parseFloat(this.cropPrice.selling_price) > 0)) {
        return
      }

      const newId = this.generateId(10)

      const priceHistory = _.find(this.rawData.crop_prices, {
        cropping_season: this.cropPrice.cropping_season,
        cropping_year: this.cropPrice.cropping_year,
        crop: this.cropPrice.crop
      })

      if (priceHistory) {
        this.$bvModal.msgBoxOk('Oops! Price history already exists.', {
          title: 'Validation Error',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          centered: true
        })
        return
      }

      const crop = _.find(this.list.crops, { value: this.cropPrice.crop })

      this.cropPrice.id = newId
      this.cropPrice.active = 1
      this.cropPrice.crop_name = crop?.text

      this.rawData.crop_prices.push({
        ...this.cropPrice
      })

      this.onCropPriceReset()
    },

    onCropPriceEdit (current) {
      this.state.cropPriceEditing = true
      this.cropPrice.id = current.id
      this.cropPrice.active = current.active
      this.cropPrice.cropping_season = current.cropping_season
      this.cropPrice.cropping_year = current.cropping_year
      this.cropPrice.crop = current.crop
      this.cropPrice.total_harvested = current.total_harvested
      this.cropPrice.selling_condition = current.selling_condition
      this.cropPrice.selling_price = current.selling_price
    },

    onCropPriceUpdate () {
      const cropPriceHistory = _.find(this.rawData.crop_prices, { id: this.cropPrice.id })

      if (cropPriceHistory) {
        cropPriceHistory.cropping_season = this.cropPrice.cropping_season
        cropPriceHistory.cropping_year = this.cropPrice.cropping_year
        cropPriceHistory.crop = this.cropPrice.crop
        cropPriceHistory.total_harvested = this.cropPrice.total_harvested
        cropPriceHistory.selling_condition = this.cropPrice.selling_condition
        cropPriceHistory.selling_price = this.cropPrice.selling_price

        // add to dirty list
        if (_.indexOf(this.rawData.dirty_crop_prices, this.cropPrice.id) < 0) {
          this.rawData.dirty_crop_prices.push(this.cropPrice.id)
        }
        this.state.cropPriceEditing = false
        this.onCropPriceReset()
      }
    },

    onCropPriceCancelUpdate () {
      this.state.cropPriceEditing = false
      this.onCropPriceReset()
    },

    onCropPriceRemove (current) {
      if (!isNaN(parseInt(current.id))) {
        return
      }

      this.rawData.crop_prices = _.remove(this.rawData.crop_prices, function (o) {
        return o.id.toString() !== current.id.toString()
      })
    },

    onViewRemarks (current) {
      this.selected.log = { ...current }
      this.$bvModal.show('modal-view-remarks')
    },

    onFilterChanged () {
      this.$refs.table.refresh()
    }
  }
}
</script>
